<template>
  <!-- HEADER -->
  <header id="header">
    <!-- NAV -->
    <div id="nav">
      <!-- Top Nav -->
      <div id="nav-top">
        <div class="container">
          <!-- social -->
          <ul class="nav-social">
            <li>
              <a
                href="https://www.facebook.com/pedlinepediatria/"
                rel="noreferrer"
                target="_blank"
              >
                <i class="fa fa-facebook"></i>
              </a>
            </li>
            <!-- <li>
              <a href="#">
                <i class="fa fa-twitter"></i>
              </a>
            </li>-->
            <li>
              <a
                href="https://www.instagram.com/pedlinepediatria/"
                rel="noreferrer"
                target="_blank"
              >
                <i class="fa fa-instagram"></i>
              </a>
            </li>
          </ul>
          <!-- /social -->

          <div id="google_translate_element"></div>

          <!-- logo -->
          <div class="nav-logo">
            <a href="#/" class="logo">
              <img src="../assets/images/pedline-logo.png" />
            </a>
          </div>
          <!-- /logo -->

          <!-- search & aside toggle -->
          <div class="nav-btns">
            <div class="search-holder">
              <input
                @keyup.enter="search"
                v-model="searchText"
                type="text"
                placeholder="Buscar"
              />
              <i @click="search" class="fa fa-search"></i>
            </div>
            <button class="aside-btn hidden-lg">
              <i class="fa fa-bars"></i>
            </button>
          </div>
          <!-- /search & aside toggle -->
        </div>
      </div>
      <!-- /Top Nav -->

      <!-- Main Nav -->
      <div id="nav-bottom">
        <div class="container">
          <ul class="nav-menu smaller-header">
            <!-- <li>
              <a href="#">Artigos</a>
            </li>-->
            <li class="has-dropdown">
              <a href>Faixa etária</a>
              <div class="dropdown">
                <div class="dropdown-body">
                  <ul class="dropdown-list">
                    <li v-for="cat in categories" :key="cat.id">
                      <a :href="`#/busca?category=${cat.title}`">{{
                        cat.title
                      }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a
                href="#/busca?urgencia=1"
                :class="{
                  active: $route.name == 'Search' && $route.query.urgencia
                }"
                >Urgências</a
              >
            </li>
            <li>
              <a
                href="#/quemSomos"
                :class="{ active: $route.name == 'QuemSomos' }"
                >Quem Somos</a
              >
            </li>
            <li>
              <a
                href="#/parceiros"
                :class="{ active: $route.name == 'Parceiros' }"
                >Parceiros e Apoio</a
              >
            </li>
            <li>
              <a href="#/contato" :class="{ active: $route.name == 'Contato' }"
                >Contato e Imprensa</a
              >
            </li>
            <li>
              <a
                href="#/sejaEditor"
                :class="{ active: $route.name == 'SejaEditor' }"
                >Seja um Editor</a
              >
            </li>
            <!-- <li>
              <a
                style="font-weight:bold; color:#e40084;"
                href="#/doacao"
                :class="{ active: $route.name == 'Doacao' }"
                >Doações</a
              >
            </li> -->
          </ul>
        </div>
      </div>
      <!-- /Main Nav -->

      <!-- Aside Nav -->
      <div id="nav-aside">
        <ul class="nav-aside-menu">
          <li>
            <a href="#/">HOME</a>
          </li>
          <li @click="showSubmenu = !showSubmenu" class="has-dropdown">
            <a>Faixa etária</a>
            <transition enter-active-class="animated fadeInDown">
              <ul v-show="showSubmenu" class="dropdown">
                <li v-for="cat in categories" :key="cat.id">
                  <a :href="`#/busca?category=${cat.title}`">{{ cat.title }}</a>
                </li>
              </ul>
            </transition>
          </li>
          <li>
            <a href="#/busca?urgencia=1" class="active">Urgências</a>
          </li>
          <li>
            <a href="#/quemSomos">Quem Somos</a>
          </li>
          <li>
            <a href="#/parceiros">Parceiros e Apoio</a>
          </li>
          <li>
            <a href="#/contato">Contato e Imprensa</a>
          </li>
          <li>
            <a href="#/sejaEditor">Seja um Editor</a>
          </li>
          <li>
            <a style="font-weight:bold; color:#e40084;" href="#/doacao"
              >Doações</a
            >
          </li>
        </ul>
        <button class="nav-close nav-aside-close">
          <span></span>
        </button>
      </div>
      <!-- /Aside Nav -->
    </div>
    <!-- /NAV -->
  </header>
  <!-- /HEADER -->
</template>
<script>
import http from "@/http";
export default {
  name: "Header",
  data() {
    return {
      showSubmenu: false,
      searchText: "",
      categories: []
    };
  },
  created() {
    this.loadCategories();
  },
  mounted() {
    var gTranslator = document.createElement("script");
    gTranslator.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    );
    var docHead = document.getElementsByTagName("head")[0];
    docHead.appendChild(gTranslator);
    gTranslator.onload = () => {
      setTimeout(() => {
        new google.translate.TranslateElement(
          {
            pageLanguage: "pt"
          },
          "google_translate_element"
        );
      }, 500);
    };
  },
  methods: {
    search() {
      window.location = `#/busca?text=${this.searchText}`;
    },
    loadCategories() {
      http
        .get("category")
        .then(response => {
          this.categories = response.data.list;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
li a {
  position: relative;
}
li a.active {
  /* background-color: var(--secondary); */
  color: var(--secondary) !important;
}

li a:hover {
  color: var(--secondary);
}

li a::before {
  position: absolute;
  content: "";
  width: 0;
  height: 3px;
  background-color: var(--secondary);
  bottom: -2px;
  left: 0;
  right: 0;
  margin: 0 auto;
  transition: width 0.3s ease;
}

li a.active::before,
li a:hover::before {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue